import { Controller } from "@hotwired/stimulus";
import { paramCase } from "change-case";

export default class extends Controller {
  // static values = {
  //   song: Object
  // }

  connect() {
    this.songModal = document.getElementById("songModal");
    this.songModal.addEventListener(
      "show.bs.modal",
      this.onModalShow.bind(this)
    );

    
  }

  disconnect() {
    this.songModal.removeEventListener(
      "show.bs.modal",
      this.onModalShow.bind(this)
    );
  }

  onModalShow(event) {
    //console.log('values!',this.songValue)

    // Button that triggered the modal
    var button = event.relatedTarget;
    // Extract info from data-bs-* attributes
    var songName = button.getAttribute("data-song-name");
    var songValueObj = JSON.parse(button.getAttribute("data-manage-song-song-value") )

    for(let k in songValueObj){
      this.songModal.setAttribute(`data-manage-song-modal-${paramCase(k)}-value`, songValueObj[k]);
    }
    // If necessary, you could initiate an AJAX request here
    // and then do the updating in a callback.
    //
    // Update the modal's content.
    //var modalTitle = songModal.querySelector('.modal-title')

  }


}
